import React, { useEffect, useState } from "react";
import { Container, Modal } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import "./galary.css";

const images = [
  { id: "1", imageName: "demo.jpg", tag: "cultural" },
  { id: "5", imageName: "hr_sir (1).jpg", tag: "social" },
  { id: "6", imageName: "1.jpg", tag: "cultural" },
  { id: "7", imageName: "2.jpg", tag: "social" },
  { id: "8", imageName: "3.jpg", tag: "cultural" },
  // { id: "9", imageName: "4.jpg", tag: "awards" },   
  // { id: "10", imageName: "5.jpg", tag: "social" },
  // { id: "11", imageName: "6.jpg", tag: "news" },
  // { id: "12", imageName: "7.jpg", tag: "awards" },
  { id: "9", imageName: "IMG_8459.jpg", tag: "cultural" },
  { id: "10", imageName: "IMG_8462.jpg", tag: "cultural" },
  { id: "11", imageName: "IMG_8463.jpg", tag: "cultural" },
  { id: "12", imageName: "IMG_8466.jpg", tag: "cultural" },
  { id: "13", imageName: "IMG_8467.jpg", tag: "cultural" },
  { id: "14", imageName: "IMG_8469.jpg", tag: "cultural" },

  { id: "13", imageName: "slider12.jfif", tag: "celebration" },
  { id: "14", imageName: "slider13.jfif", tag: "news" },
  { id: "15", imageName: "slider14.jfif", tag: "news" },
  { id: "16", imageName: "slider15.jfif", tag: "awards" },
  { id: "17", imageName: "slider16.jfif", tag: "celebration" },
  { id: "18", imageName: "slider17.jfif", tag: "celebration" },
  { id: "19", imageName: "slider18.jfif", tag: "celebration" },
  { id: "20", imageName: "slider19.jfif", tag: "celebration" },
  { id: "21", imageName: "slider20.jfif", tag: "celebration" },
  { id: "22", imageName: "slider21.jfif", tag: "celebration" },
  { id: "23", imageName: "slider22.jfif", tag: "awards" },
  { id: "24", imageName: "slider23.jfif", tag: "celebration" },
  { id: "25", imageName: "slider24.jfif", tag: "celebration" },
  { id: "26", imageName: "slider25.jfif", tag: "awards" },
  { id: "27", imageName: "slider26.jfif", tag: "celebration" },
  { id: "28", imageName: "slider27.jfif", tag: "celebration" },
  { id: "29", imageName: "slider28.jfif", tag: "celebration" },
  { id: "30", imageName: "slider29.jfif", tag: "celebration" },
  { id: "31", imageName: "slider30.jfif", tag: "celebration" },
  { id: "32", imageName: "slider31.jfif", tag: "awards" },
];

const Gallery = () => {
  const [tag, setTag] = useState("all");
  const [filteredImages, setFilteredImages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  // Filter images based on active tag
  useEffect(() => {
    if (tag === "all") {
      setFilteredImages(images);
    } else {
      setFilteredImages(images.filter((image) => image.tag === tag));
    }
  }, [tag]);

  // Open modal for selected image
  const openImageModal = (imageName, index) => {
    setSelectedImage(imageName);
    setCurrentIndex(index);
    setShowModal(true);
  };

  // Lightbox previous image navigation
  const prevImage = () => {
    const newIndex =
      (currentIndex - 1 + filteredImages.length) % filteredImages.length;
    setCurrentIndex(newIndex);
    setSelectedImage(`/images/${filteredImages[newIndex].imageName}`);
  };

  // Lightbox next image navigation
  const nextImage = () => {
    const newIndex = (currentIndex + 1) % filteredImages.length;
    setCurrentIndex(newIndex);
    setSelectedImage(`/images/${filteredImages[newIndex].imageName}`);
  };

  // Available unique tags based on images list
  const tags = ["all", "social", "cultural", "awards", "news", "celebration"];

  // Framer Motion Animation Variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.04,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9, y: 15 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 110,
        damping: 15,
      },
    },
    exit: {
      opacity: 0,
      scale: 0.85,
      y: 10,
      transition: { duration: 0.2 },
    },
  };

  return (
    <div className="gallery-page-wrapper">
      {/* Background decorations */}
      <div className="gallery-bg-decorations">
        <div className="gallery-decor-blob gallery-decor-blob-1"></div>
        <div className="gallery-decor-blob gallery-decor-blob-2"></div>
      </div>

      <Container className="py-5 mt-5 position-relative" style={{ zIndex: 2 }}>
        {/* Header section */}
        <div className="text-center mb-5 mt-4">
          <motion.h2
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="gallery-title"
          >
            Gallery
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="gallery-subtitle"
          >
            Capture moments of celebration, awards, news, and our cultural/social events at The Innovative Solutions.
          </motion.p>
        </div>

        {/* Liquid Tab Filters */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="gallery-tabs-container"
        >
          {tags.map((tagName) => (
            <button
              key={tagName}
              className={`glass-gallery-tab ${tag === tagName ? "active" : ""}`}
              onClick={() => setTag(tagName)}
            >
              {tag === tagName && (
                <motion.span
                  layoutId="activeGalleryIndicator"
                  className="active-gallery-indicator"
                  transition={{ type: "spring", stiffness: 350, damping: 28 }}
                />
              )}
              <span style={{ position: "relative", zIndex: 1 }}>{tagName}</span>
            </button>
          ))}
        </motion.div>

        {/* Staggered Grid list of Images */}
        <motion.div
          layout
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="row g-4 justify-content-center"
        >
          <AnimatePresence mode="popLayout">
            {filteredImages.map((image, index) => (
              <motion.div
                layout
                key={image.id}
                variants={cardVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                onClick={() => openImageModal(`/images/${image.imageName}`, index)}
                className="col-12 col-sm-6 col-md-4 col-lg-3"
              >
                <div className="glass-gallery-card">
                  <div className="gallery-img-wrapper">
                    <img
                      src={`/images/${image.imageName}`}
                      alt={`Gallery item ${image.id}`}
                      className="gallery-img"
                    />

                    {/* Hover search overlay */}
                    <div className="gallery-card-overlay">
                      <div className="gallery-overlay-inner">
                        <span className="gallery-zoom-icon">
                          <i className="bi bi-zoom-in"></i>
                        </span>
                        <span className="gallery-tag-badge">{image.tag}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

        {/* Empty State */}
        <AnimatePresence>
          {filteredImages.length === 0 && (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="gallery-empty-container mt-4"
            >
              <i className="bi bi-image-alt"></i>
              <h4>No Images Found</h4>
              <p className="text-secondary mb-0">There are no gallery photos matching the selected category.</p>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Custom Lightbox Modal */}
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          contentClassName="gallery-modal-content"
          size="lg"
        >
          <Modal.Body className="p-0 position-relative">
            {/* Close Button */}
            <button
              className="modal-close-btn-custom"
              onClick={() => setShowModal(false)}
            >
              <i className="bi bi-x-lg"></i>
            </button>

            {/* Lightbox Navigation Buttons */}
            {filteredImages.length > 1 && (
              <div className="modal-navigation-custom">
                <button
                  className="nav-btn-custom prev-btn-custom"
                  onClick={prevImage}
                >
                  <i className="bi bi-chevron-left"></i>
                </button>

                <button
                  className="nav-btn-custom next-btn-custom"
                  onClick={nextImage}
                >
                  <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            )}

            {/* Animated Image display */}
            <div className="modal-image-wrapper">
              <AnimatePresence mode="wait">
                <motion.img
                  key={selectedImage}
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.95 }}
                  transition={{ duration: 0.25 }}
                  src={selectedImage}
                  alt="Selected gallery view"
                  className="modal-image-custom"
                />
              </AnimatePresence>
            </div>

            {/* Counter display */}
            <div className="image-counter-custom">
              {currentIndex + 1} / {filteredImages.length}
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </div>
  );
};

export default Gallery;
